export const MOBILE_BREAKPOINT = 768;
export enum DeviceType {
  Web = 'Web',
  IOS = 'IOS',
  Android = 'Android'
}
